var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 91 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.925 18.11c-22.4-2.8-35.2-15.8-35.7-16.3-1.2-1.3-3-1.9-4.7-1.8-1.4.1-2.7.8-3.7 1.8-.1.1-12.9 13.4-35.6 16.3-3.1.4-5.5 3.2-5.2 6.3 3.7 51.5 41 69.3 42.6 70 .8.4 1.6.5 2.4.5.8 0 1.7-.2 2.4-.5 1.6-.7 38.9-18.5 42.6-70.1.2-3-2.1-5.8-5.1-6.2zm-23.6 41.8c0 2.4-2 4.4-4.4 4.4h-23.9c-2.4 0-4.4-2-4.4-4.4v-15.7c0-2.4 2-4.4 4.4-4.4h1.3v-6.9c0-5.9 4.8-10.6 10.6-10.6s10.6 4.8 10.6 10.6v6.9h1.5c2.4 0 4.4 2 4.4 4.4v15.7h-.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.025 33.01c0-3.3-2.7-6-6-6s-6 2.7-6 6v6.9h12v-6.9zm-2.2 14.1l-5 5-2.5-2.5c-.9-.9-2.4-.9-3.3 0-1 .9-1 2.4 0 3.3l4.2 4.2c.5.5 1 .7 1.6.7.6 0 1.2-.2 1.6-.7l6.6-6.6c.9-.9.9-2.4 0-3.3-.9-1-2.3-1-3.2-.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.c7e822e56d5492b054b5f9fab6d22fe5.svg";
export { ForwardRef as ReactComponent };